import { lazyRemoveAttachmentPreviews } from 'owa-mail-attachment-previews';
import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import getListViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import { getConversationCache } from 'owa-mail-store/lib/store/conversationCache';
import { mutatorAction } from 'satcheljs';
import { lazyRemoveMeetingMessagesFromStore } from 'owa-listview-rsvp';

export default function removeConversationData(rowKey: string, tableView: TableView): void {
    const tableConversationRelationKey = getTableToRowRelationKey(rowKey, tableView.id);
    const tableConversationRelations = getListViewStore().tableViewConversationRelations;

    if (!tableConversationRelations.has(tableConversationRelationKey)) {
        throw new Error('Conversation not found in store');
    }

    const conversationId = tableConversationRelations.get(tableConversationRelationKey)?.id;
    const itemIdsForConversation = tableConversationRelations.get(
        tableConversationRelationKey
    )?.itemIds;

    let converationFoundInOtherTables = false;
    for (const table of getListViewStore().tableViews.values()) {
        // We should not refer to the current table
        if (
            table.id != tableView.id &&
            conversationId &&
            table.rowIdToRowKeyMap.get(conversationId)
        ) {
            converationFoundInOtherTables = true;
            break;
        }
    }

    const conversationToRemove = !converationFoundInOtherTables ? conversationId : undefined;
    removeConversationDataMutator(tableConversationRelationKey, conversationToRemove);

    // Additional cleanup operations
    if (!converationFoundInOtherTables && conversationId) {
        // Remove attachment preview well and attachment view states for this conversation
        lazyRemoveAttachmentPreviews.importAndExecute(conversationId);
        if (itemIdsForConversation) {
            lazyRemoveMeetingMessagesFromStore.importAndExecute(itemIdsForConversation);
        }

        // Remove cached ConversationItemParts from conversationCache if exists. Eviction telemetry
        // and compressed-sidecar cleanup happen in the cache delete callback
        // (reportConversationCacheEviction) so they observe the compressed state before teardown.
        getConversationCache().remove(conversationId);
    }
}

const removeConversationDataMutator = mutatorAction(
    'removeConversationData',
    (tableConversationRelationKey: string, conversationId?: string) => {
        getListViewStore().tableViewConversationRelations.delete(tableConversationRelationKey);

        // Remove conversation from store if conversationId is provided which will only be provided if the conversation is not found in other tables
        if (conversationId) {
            getListViewStore().conversationItems.delete(conversationId);
        }
    }
);
